import { useState } from "react"
import ContactUs from "./data/ContactUs"

export default function Contact() {
  const [selectedContact, setSelectedContact] = useState(null)

  return (
    <>
      <div className="fgh-contact-us-footer" id="contactUs">
        <strong className="fgh-strong-style"></strong>
        <div className="fgh-contact-us-footer--contact">
          <div
            onClick={() => setSelectedContact("mobile")}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/images/icon/contact-us/mobile-app-icon.webp"
              alt="Mobile"
            />
          </div>
          <div
            onClick={() => setSelectedContact("viber")}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/images/icon/contact-us/viber-app-icon.webp"
              alt="Viber"
            />
          </div>
          {/* <div
            onClick={() => setSelectedContact("whatsapp")}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/images/icon/contact-us/whatsup-app-icon.webp"
              alt="WhatsApp"
            />
          </div> */}
          <div
            onClick={() => setSelectedContact("telegram")}
            style={{ cursor: "pointer" }}
          >
            <img src="/images/icon/social-media/telegram.webp" alt="Telegram" />
          </div>
          <div>
            <a
              href="mailto:support@fgh.fun"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/images/icon/contact-us/email-app-icon.webp"
                alt="Email"
              />
            </a>
          </div>
        </div>
      </div>
      {selectedContact && selectedContact !== "email" && (
        <ContactUs
          type={selectedContact}
          onClose={() => setSelectedContact(null)}
        />
      )}
    </>
  )
}
